export const functionalOptionCode = (
  { functionalOptionCodeMappings },
  { functionalCode },
) => functionalOptionCodeMappings.byId[functionalCode];

export const functionalOptionCodeMappings = ({
  functionalOptionCodeMappings,
}) => functionalOptionCodeMappings.byId;
